import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  Input,
  SimpleGrid,
  Text,
  Wrap,
  Heading,
  Box,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { MdMessage, MdPlayCircleFilled } from "react-icons/md";
import * as yup from "yup";
import styled from "@emotion/styled";

import useAxios from "axios-hooks";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { activeConnectorState } from "atoms/activeConnectorState";
import { toastState } from "atoms/toastState";
import Card from "components/card/Card";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";
//import { TbMessage } from "react-icons/tb";
const GlassMorphismBox = styled(Box)`
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 32px 0 rgba(35, 169, 121, 0.2);
  transition: all 0.3s ease;
  border-radius: 12px;
  padding: 1rem;
  width: 100%;
`;

const RemoteStart = ({ refresh }) => {
  const activeConnector = useRecoilValue(activeConnectorState);
  const setToast = useSetRecoilState(toastState);
  const [{ data, loading, error }, execute] = useAxios(
    { method: "POST", url: "/api/ocpp16/charging/start" },
    { manual: true }
  );
  const validationSchema = yup.object().shape({
    IdTag: yup.string().required("Please enter IdTag"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const controllers = [
    {
      name: "IdTag",
      label: "IdTag",
      type: "input",
      helperText: "Enter IdTag/MobileNumber",
    },
  ].map((ele, index) => {
    return (
      <Controller
        key={index}
        name={ele.name}
        control={control}
        render={({ field }) => (
          <FormControl as="fieldset" maxW={200} isInvalid={errors[ele.name]}>
            <FormLabel as="legend" fontSize={18}>
              {ele.label}
            </FormLabel>
            {ele.type === "input" && (
              <Input
                required
                maxLength={10}
                placeholder="Enter IdTag"
                {...field}
                type="text"
              />
            )}
            <FormHelperText>{ele?.helperText}</FormHelperText>
            <FormErrorMessage mb={"20px"}>
              {errors[ele.name] && errors[ele.name].message}
            </FormErrorMessage>
          </FormControl>
        )}
      />
    );
  });

  const operation = async () => {
    // const formValues = getValues();
    let body = {};
    body["EvseSerialId"] = activeConnector.EvseSerialId;
    body["StationId"] = activeConnector.EvseId;
    body["IdTag"] = ".";
    try {
      const response = await execute({ data: body });
      setToast({
        isOpen: true,
        title: "Charging Started Successfully",
        description: response.data.data.Message,
        status: "success",
      });
    } catch (error) {
      const err = error?.response?.data?.error;
      logger.log(error);
      setToast({
        isOpen: true,
        title: "Error occured when starting Charger",
        description: err ? err : null,
        status: "error",
      });
    }
    refresh();
  };
  return loading ? (
    <LoadingSpinner />
  ) : (
    <Box
      position="relative"
      height="100%"
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      pt={8}
    >
      <Flex
        position="absolute"
        top={0}
        left={0}
        right={0}
        borderBottom="2px solid"
        borderColor="rgba(35, 169, 121, 0.3)"
        pb={2}
        mb={4}
        px={4}
        justifyContent="center"
        alignItems="center"
      >
        <Icon as={MdPlayCircleFilled} color="brand.500" mr={2} boxSize={5} />
        <Heading size="md" color="gray.700" fontWeight={600}>
          Remote Start
        </Heading>
      </Flex>

      <GlassMorphismBox
        mt={8}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Button
          borderRadius="full"
          textColor={"white"}
          bg="brand.500"
          _hover={{
            transform: "translateY(-2px)",
            boxShadow: "0 8px 16px rgba(35, 169, 121, 0.3)",
          }}
          rightIcon={<MdMessage />}
          onClick={operation}
          isLoading={loading}
          px={8}
          py={6}
          fontSize="md"
          transition="all 0.3s ease"
        >
          Start Charging
        </Button>
      </GlassMorphismBox>
    </Box>
  );
};

export default RemoteStart;
